// extracted by mini-css-extract-plugin
export default {"ServiceSampleStyl":"ServiceSampleModal_ServiceSampleStyl__Diyx6","sampleItemStyl":"ServiceSampleModal_sampleItemStyl__7o0t7","colspan2":"ServiceSampleModal_colspan2__RBBDE"};